import { Badge, HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing } from '@genial/design-tokens';
import { Text } from 'native-base';
import React from 'react';

interface SectionWrapperProps {
  title: string;
  children: React.ReactNode;
  completed?: boolean;
}

export const SectionWrapper: React.FC<SectionWrapperProps> = ({ title, children, completed }) => {
  return (
    <VStack bg="white" borderRadius={BoxRadius.sm}>
      <HStack
        p={Spacing['inline.xxs']}
        borderBottomWidth={1}
        borderBottomColor={Color['neutral.lightest']}
        alignItems="center"
        justifyContent="space-between">
        <Text color="neutral.black" variant="semibold">
          {title}
        </Text>
        {completed && (
          <Badge testId="section-completed" backgroundColor="feedback.success.default">
            CONCLUÍDO
          </Badge>
        )}
      </HStack>
      {children}
    </VStack>
  );
};
